import type { Assistant, ConversationAssistant } from '../api/MgaApi';
import { isLocalAssistantId } from '../api/LocalAssistants';

export function getAssistantLogoUrl(
  assistant: ConversationAssistant | Assistant,
): string | undefined {
  if ('logoUrl' in assistant) {
    return assistant.logoUrl;
  }
  if ('logo_url' in assistant) {
    return assistant.logo_url;
  }
  return undefined;
}

/** Local assistants without a custom logo use the generic assistant icon. */
export function shouldShowLocalAssistantIconFallback(
  assistant: ConversationAssistant | Assistant,
): boolean {
  return isLocalAssistantId(assistant.id) && !getAssistantLogoUrl(assistant);
}
